
import { Vue, Component, Prop } from 'vue-property-decorator';
import TrackingScanItem from '@/features/shipment-history/components/details/trackingDetails/TrackingScanItem.vue';
import { TrackingScan } from '@/features/shipment-history/types';

@Component({
  components: {
    TrackingScanItem,
  },
})
export default class TrackingScans extends Vue {
  @Prop({ required: true }) scans!: TrackingScan[];
}
